import _ from 'lodash'
import fullName from '@/helpers/full_name'
import avatar from '@/helpers/avatar'

/**
 *
 * @param users collection of users or plain user object
 * @param type array of transforms to apply
 */
function transform(users, type) {
  let result = users

  function transformImage(user) {
    if (_.isEmpty(user.avatar)) {
      user.avatar = avatar.by(user)
    }
  }

  function transformFullName(user) {
    user.full_name = fullName.by(user)
  }

  function transformSubtitle(user) {
    user.subtitle = user.work_position ? user.work_position.title : ''
  }

  function transformRating(user) {
    user.rating = +user.rating >= 0.01 && +user.voices >= 1 ? (+user.rating / +user.voices).toFixed(2) : 0
  }

  if (_.isArray(users)) {
    result = _.forEach(users, user => {
      if (type.includes('image')) {
        transformImage(user)
      }
      if (type.includes('fullName')) {
        transformFullName(user)
      }
      if (type.includes('subtitle')) {
        transformSubtitle(user)
      }
      if (type.includes('rating')) {
        transformRating(user)
      }
    })
  }
  if (_.isPlainObject(users)) {
    const user = users
    if (type.includes('image')) {
      transformImage(user)
    }
    if (type.includes('fullName')) {
      transformFullName(user)
    }
    if (type.includes('subtitle')) {
      transformSubtitle(user)
    }
    if (type.includes('rating')) {
      transformRating(user)
    }
    result = user
  }
  return result
}

export default { transform }
